import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useAllRelationUserBookIdsByBook = (bookId: string | undefined) : string[] => {
  const relationUserBookDb = useSelector((state: RootState) => state.relationUserBookDb);
  const ids = Object.keys(relationUserBookDb.relationUserBooks).filter(id => relationUserBookDb.relationUserBooks[id].bookId === bookId);

  return ids;
}

export default useAllRelationUserBookIdsByBook;
